import { render, staticRenderFns } from "./payment-modes.vue?vue&type=template&id=00fdb85b&scoped=true&lang=html&"
import script from "./payment-modes.vue?vue&type=script&lang=js&"
export * from "./payment-modes.vue?vue&type=script&lang=js&"
import style0 from "./payment-modes.vue?vue&type=style&index=0&id=00fdb85b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fdb85b",
  null
  
)

export default component.exports